import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { generateColor } from '@/templates/Cadastro/Funcionarios/organismos/forms/TabelaHorario/utils'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { TabelaHorarios, tabelaHorarios } from 'service/api'

const columns: GridColDefPro[] = [
    {
        field: 'codigo',
        headerName: 'Código',
        width: 140,
        type: 'number',
        valueGetter: params => params.row.codigo || params.row.id,
    },
    {
        field: 'nome',
        headerName: 'Descrição',
        flex: 1,
        renderCell: ({ value }) => {
            const { dark } = generateColor(value)
            return (
                <>
                    <div
                        className="rounded-full size-4 border mr-2"
                        style={{
                            backgroundColor: dark,
                        }}
                    />
                    <span title={value}>{value}</span>
                </>
            )
        },
    },
    {
        field: 'entradaAntes',
        headerName: 'Entrada Antes',
        width: 140,
        valueGetter: params => {
            return params.row.tolerancias.entradaAntes?.toString()
        },
    },
    {
        field: 'entradaDepois',
        headerName: 'Entrada Depois',
        width: 140,
        valueGetter: params => {
            return params.row.tolerancias.entradaDepois?.toString()
        },
    },
    {
        field: 'saidaAntes',
        headerName: 'Saida Antes',
        width: 140,
        valueGetter: params => {
            return params.row.tolerancias.saidaAntes?.toString()
        },
    },
    {
        field: 'saidaDepois',
        headerName: 'Saida Depois',
        width: 140,
        valueGetter: params => {
            return params.row.tolerancias.saidaDepois?.toString()
        },
    },
    {
        ...optionsColumn,
        field: '__editar',
        renderCell: ({ id }) =>
            hasPermission(['update', 'TabelaDeHorários'], () => (
                <IconButton title="Editar" href={`${id}/editar`}>
                    <PencilIcon />
                </IconButton>
            )),
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: ({ id }) =>
            hasPermission(['delete', 'TabelaDeHorários'], () => (
                <IconButton title="Excluir" href={`${id}/excluir`}>
                    <Trash2Icon className="text-red-500" />
                </IconButton>
            )),
    },
]

export default function TabelaHorario() {
    const { data = [], isLoading } = tabelaHorarios.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Cadastros', 'Tabela de horários']}
                />
                <ContentGuide.DataGrid
                    onAdd
                    rows={data}
                    columns={columns}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-tabela-horario',
                        },
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useTabelaHorariosOutletContext() {
    return useOutletContext<{ data: TabelaHorarios[] }>()
}
